import { store } from "../../../store";
import employeeActions from "../../../actions/employeeActions";
import { getAccessProfile } from "../../../reducers/sessionReducer";
import sortObjectsArrayByProperty from "../../../utils/sortObjectsArrayByProperty";

const fiSpreadsheetTableColumns = [
  // {
  //   name: "assessorId",
  //   title: "Assessor",
  //   editable: false,
  //   notRenderable: getAccessProfile(store.getState()) !== "Gestor",
  //   type: "object-select",
  //   meta: { valueKey: "id", labelKey: "name" },
  //   options: [],
  //   async: {
  //     fetch: () => store.dispatch(employeeActions.fetchAll()),
  //     fetchDelay: 500,
  //     mapSuccessfulResult: (response) =>
  //       sortObjectsArrayByProperty(
  //         Object.values(response.data.entities.employees),
  //         "name",
  //       ),
  //     mapProps: ({ response, ...others }) => ({ ...others, options: response }),
  //   },
  //   getCellValue: (row) => (row.assessor || {}).name,
  //   width: 159,
  // },
  {
    name: "createdAt",
    title: "Data da importação",
    width: 180,
    type: "date",
  },
  {
    name: "createdByName",
    title: "Importado por",
    width: 160,
  },
  {
    name: "status",
    title: "Status",
    width: 90,
  },
  {
    name: "originalFileName",
    title: "Nome do arquivo",
    width: 300,
  },
  {
    name: "sheetName",
    title: "Nome da aba",
    width: 250,
  },
  {
    name: "headersLine",
    title: "Linha dos cabeçalhos",
    width: 160,
  },
  {
    name: "errorMessage",
    title: "Detalhes do erro",
    width: 300,
  },
];

export default fiSpreadsheetTableColumns;
